module.exports = __webpack_public_path__ + "static/img/gray.23b25ac1.png";